<div>
  <div class="profile-image-wrapper">
    <div class="profile-image" [ngStyle]="{ 'height.px': size, 'width.px': size }">
      <span class="text-sm fw-bold" [ngStyle]="{ 'fontSize.px': fontSize }">{{ user | userInitials }}</span>
    </div>
  </div>
</div>
